import { render, staticRenderFns } from "./RankRolesGrid.vue?vue&type=template&id=6208607e&scoped=true&"
import script from "./RankRolesGrid.vue?vue&type=script&lang=js&"
export * from "./RankRolesGrid.vue?vue&type=script&lang=js&"
import style0 from "./RankRolesGrid.vue?vue&type=style&index=0&id=6208607e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6208607e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VSimpleTable})
